var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{ref:"select",attrs:{"autofocus":_vm.autofocus,"items":_vm.binItems,"label":"Bin","item-value":"id","item-text":"name","value":_vm.value,"rules":_vm.localRules,"return-object":_vm.returnObject,"disabled":_vm.disabled,"no-data-text":"No empty bins available","inputmode":"numeric","pattern":"[0-9]*"},on:{"input":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }